const _excluded = ["align", "className", "color", "display", "wordBreak", "lineHeight", "numericSpacing", "size", "typeface", "visuallyHidden", "weight", "wrap"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import AlignContext, { inertAlignContextProps } from "../Align/AlignContext";
import { useAlignContext } from "../Align/useAlignContext";
import { getStyle } from "../Align/AlignProps";
import classNames from 'clsx';

const Text = props => {
  const {
    align,
    className,
    color,
    display,
    wordBreak,
    lineHeight,
    numericSpacing,
    size,
    typeface,
    visuallyHidden,
    weight,
    wrap
  } = props,
        remaining = _objectWithoutProperties(props, _excluded);

  const textClasses = classNames(className, `Text-color--${color}`, align === 'center' && 'Text-align--center', align === 'left' && 'Text-align--left', align === 'right' && 'Text-align--right', size === 11 && 'Text-fontSize--11', size === 12 && 'Text-fontSize--12', size === 13 && 'Text-fontSize--13', size === 14 && 'Text-fontSize--14', size === 15 && 'Text-fontSize--15', size === 16 && 'Text-fontSize--16', size === 20 && 'Text-fontSize--20', size === 24 && 'Text-fontSize--24', size === 28 && 'Text-fontSize--28', size === 32 && 'Text-fontSize--32', size === 48 && 'Text-fontSize--48', size === 56 && 'Text-fontSize--56', weight === 'regular' && 'Text-fontWeight--regular', weight === 'medium' && 'Text-fontWeight--medium', weight === 'bold' && 'Text-fontWeight--bold', lineHeight === 16 && 'Text-lineHeight--16', lineHeight === 20 && 'Text-lineHeight--20', lineHeight === 24 && 'Text-lineHeight--24', lineHeight === 28 && 'Text-lineHeight--28', lineHeight === 32 && 'Text-lineHeight--32', lineHeight === 36 && 'Text-lineHeight--36', lineHeight === 40 && 'Text-lineHeight--40', lineHeight === 56 && 'Text-lineHeight--56', lineHeight === 64 && 'Text-lineHeight--64', numericSpacing === 'proportional' && 'Text-numericSpacing--proportional', numericSpacing === 'tabular' && 'Text-numericSpacing--tabular', typeface === 'base' && 'Text-typeface--base', typeface === 'upper' && 'Text-typeface--upper', typeface === 'mono' && 'Text-typeface--mono', visuallyHidden && 'Text--visuallyHidden', wordBreak === 'all' && 'Text-wordBreak--all', wordBreak === 'normal' && 'Text-wordBreak--normal', wordBreak === 'word' && 'Text-wordBreak--word', wrap === false && 'Text-wrap--noWrap', wrap === true && 'Text-wrap--wrap');
  const {
    alignContext,
    isAligned
  } = useAlignContext();
  const textProps = size ? {
    size,
    typeface
  } : {};

  const alignProps = _objectSpread(_objectSpread({}, remaining.style), getStyle(_objectSpread({
    strategy: 'baseline',
    nestable: false,
    typeface,
    // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
    size,
    // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
    lineHeight
  }, textProps), alignContext));

  const style = Object.keys(alignProps).length ? alignProps : undefined;
  const isBlock = align || isAligned || display === 'block';
  const classes = classNames(textClasses, isBlock ? 'Text-display--block' : 'Text-display--inline');
  return /*#__PURE__*/React.createElement(AlignContext.Provider, {
    value: inertAlignContextProps
  }, /*#__PURE__*/React.createElement("span", _extends({}, remaining, {
    style: style,
    className: classes
  })));
};

Text.defaultProps = {
  color: 'default',
  display: 'inline',
  numericSpacing: 'proportional',
  typeface: 'base',
  wrap: true
};
export default Text;